/**
 * WMS1021_R01(입고등록 - 자동 LOT) 품목 라벨 빌더
 *
 * WMS1020과 달리 사용자가 LOT을 직접 관리하지 않고, 서버 저장 시 detail.updateTransportQty 기준으로
 * LOT가 자동 생성된다. 라벨은 LOT 번호가 아닌 품목코드(itemCd) 바코드로 출력한다.
 */
import { ItemLabelPrintData } from "src/apis/itemLabelApi";
import { formatDate } from "src/utils/string/stringUtil";
import { WMS1021_R01DetailDto, WMS1021_R01HeaderDto } from "./Dto_WMS1021_R01";

/** 수량 포맷 (콤마 + 단위) */
const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return '';
	return `${qty.toLocaleString()}${unit || 'EA'}`;
};

/** 품목 1건 → ItemLabelPrintData 1건 변환 */
export const WMS1021_R01_buildItemLabelData = (
	header: WMS1021_R01HeaderDto,
	detail: WMS1021_R01DetailDto,
): ItemLabelPrintData => {
	if (!header) throw new Error('입고 정보를 찾을 수 없습니다.');
	if (!detail?.itemCd) throw new Error('품목코드를 찾을 수 없습니다.');
	if ((detail.updateTransportQty || 0) <= 0) throw new Error('입고수량이 없어 라벨을 생성할 수 없습니다.');

	const transportDate = header.orderDt
		? formatDate(new Date(header.orderDt))
		: formatDate(new Date());

	return {
		itemCd: detail.itemCd || '',
		itemNm: detail.itemNm || '',
		itemSpec: detail.itemSpec || '',
		qty: formatQty(detail.updateTransportQty, detail.orderUnit || 'EA'),
		transportDate,
		storageLocation: detail.locationNm || detail.locationCd || header.warehouseNm || '',
		customer: header.customNm || '',
		customerItemCd: detail.itemCd || '',
		labelType: '[자재입고]',
	};
};

/**
 * 저장 핸들러에서 호출. Lot라벨자동출력=Y일 때만 사용.
 * 삭제 대상 제외·입고량(updateTransportQty)>0 인 품목만 골라 ItemLabelPrintData[] 반환.
 */
export const WMS1021_R01_extractUnprintedItemLabelData = (
	header: WMS1021_R01HeaderDto,
	detailList: WMS1021_R01DetailDto[],
	deletedValueIndexes: number[] = [],
): ItemLabelPrintData[] => {
	const unprintedLabelData: ItemLabelPrintData[] = [];

	detailList
		.filter(detail =>
			!deletedValueIndexes.includes(detail.valueIndex)
			&& (detail.updateTransportQty || 0) > 0
		)
		.forEach(detail => {
			try {
				unprintedLabelData.push(WMS1021_R01_buildItemLabelData(header, detail));
			} catch (error) {
				console.error(`품목 라벨 데이터 구성 실패: ${detail.itemCd}`, error);
			}
		});

	return unprintedLabelData;
};
